<script setup>

import {computed, onMounted, ref, watch} from "vue";
import ButtonPrimary from "../../../buttons/buttonPrimary.vue";

const props = defineProps({
    content: {
        type: Object,
        required: true,
    }
})

const course = ref(null);
const courseLoaded = ref(false);
const userIsLoggedIn = window.myflow.user.loggedIn;
const pageBuilderActive = window.myflow.pagebuilderActive

const loadCourse = async () => {
    try {
        const res = await axios.get(route('api.course.customerarea.show', props.content.courseId));
        if (res.data.success)    {
            course.value = res.data.course
        }
    } catch (error) {

    }
    courseLoaded.value = true
};

const updateCompletion = async (chapter) => {
    await axios.post(route('api.course.customerarea.chapter.toggle-completed', [props.content.courseId, chapter.id]))
}

watch(() => props.content.courseId, () => {
    if (props.content.courseId) {
        loadCourse();
    }
}, { immediate: true });

onMounted(() => {
    if (userIsLoggedIn) {
        loadCourse();
    }
});

</script>

<template>
    <div>
        <div v-if="userIsLoggedIn">
            <div v-if="course">
                <h2 v-if="content.showCourseTitle">{{ course.title }}</h2>
                <ul class="divide-y">
                    <li
                        v-for="(chapter, i) in course.chapters"
                        :key="i"
                        class="py-2 flex space-x-4 justify-between"
                    >
                        <div>
                            <component
                                v-if="chapter.published && (chapter.available || course.chapters[i - 1]?.completed)"
                                :is="pageBuilderActive ? 'span' : 'a'"
                                :href="route('course.customerarea.chapter.show', [course.id, chapter.id])"
                                class="mf-underline text-inherit cursor-pointer"
                            >
                                {{ chapter.title }}
                            </component>
                            <span
                                v-else
                                class="text-gray-400 cursor-not-allowed"
                            >
                                {{ chapter.title }}
                            </span>
                        </div>
                        <toggle-done
                            :content="chapter.completed"
                            @update:content="updateCompletion(chapter)"
                            class="shrink-0 w-5 h-5"
                        ></toggle-done>
                    </li>
                </ul>
            </div>
            <div v-else-if="courseLoaded && ! content.hideIfNotAvailable">
                <p>{{ content.courseNotAvailableMessage }}</p>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
